// SPDX-License-Identifier: AGPL-3.0-or-later

import {GenericErrorModal} from '@app/features/app/components/alerts/GenericErrorModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const CallNotRingableModal = observer(() => {
	const {t} = useLingui();
	return (
		<GenericErrorModal
			title={t`Unable to Start Call`}
			message={t`This user is not available to receive calls right now. They may have calls disabled.`}
		/>
	);
});
